import 'moment/locale/es';
import 'moment/locale/fr';
import moment from 'moment-timezone';

// Set timzeone to Ecuador's so we always display stuff in local time
moment.tz.setDefault('America/Guayaquil');

export default moment;
